jQuery(document).ready(function($) {

  $('input[type=radio][name="plano"]').change(function() {
    $('.plano').removeClass('checked');
    $('#'+$(this).val()).addClass('checked');
    $('.segura-nome-plano').show();
    $('.nome-plano').html($(this).data('plano'));
  });

  // Envio do plano
  var enviando_formulario = false;
  $("#form-escolhe-plano").on("submit", function(e) {
    e.preventDefault();

    if($('input[type=radio][name="plano"]:checked').val() == undefined){
      showAlert(
        "Atenção",
        "Selecione um plano para finalizar.",
        "warning"
      );
    }

    var obj = this;
    var form = $(obj);
    var submit_btn = $("#finalizar");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function() {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Aguarde...");
        },
        success: function(data) {
          console.log(data);
          volta_submit();
          if (data == "ok") {
            showAlert(
              "Sucesso",
              "Plano selecionado com sucesso, aguarde o redirecionamento...",
              "success"
            );
            setTimeout(() => {
              window.location.href = $("#dados_retorno").val();
            }, 1800);
          } else {
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function(xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        }
      });
    }
  });

});
